import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  SearchResultData,
  selectQuery,
} from "../../app/slices/SearchResultsSlice";
import {
  selectActors,
  selectAllPropPresets,
} from "../../app/slices/TrainingSlice";
import Interaction from "../../models/interactions/Interaction";
import { createSearchLookupContext } from "../../models/interactions/SearchableInteractionValues";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";
import { getAdvancedSearchMatchingResults } from "./AdvancedSearchMatching";

export function useAdvancedSearch() {
  const { getValue } = useTrainingLocalization();
  const query = useSelector(selectQuery);
  const actors = useSelector(selectActors);
  const propPresets = useSelector(selectAllPropPresets);
  const searchLookupContext = useMemo(
    () => createSearchLookupContext(actors ?? [], propPresets ?? []),
    [actors, propPresets],
  );

  const getMatchingResults = (
    searchableStrings: string[],
    takeName: string,
    interaction: Interaction,
    filterType: string
  ): SearchResultData[] =>
    getAdvancedSearchMatchingResults({
      searchableStrings,
      query,
      interaction,
      takeName,
      getValue,
      filterType,
    });

  return { getMatchingResults, searchLookupContext } as const;
}
